(function () {
  function updateArrows(swiper, prevBtn, nextBtn) {
    if (!prevBtn || !nextBtn) return;
    prevBtn.disabled = swiper.isBeginning;
    nextBtn.disabled = swiper.isEnd;
  }

  function initVideoCards(section) {
    section.querySelectorAll('.lifestyle-gallery-v2__card[data-media-type="video"]').forEach((card) => {
      card.addEventListener('click', () => {
        const video = card.querySelector('video');
        const playIcon = card.querySelector('.lifestyle-gallery-v2__play-icon');

        if (!video) return;

        video.controls = true;

        if (video.paused) {
          video.play();
          video.muted = false;
          if (playIcon) playIcon.style.display = 'none';
        } else if (video.muted) {
          video.muted = false;
        }
      });
    });
  }

  function initSection(section) {
    if (section.dataset.lifestyleV2Inited === 'true') return;
    section.dataset.lifestyleV2Inited = 'true';

    const swiperEl = section.querySelector('[data-lifestyle-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const prevBtn = section.querySelector('.lifestyle-gallery-v2__arrow--prev');
    const nextBtn = section.querySelector('.lifestyle-gallery-v2__arrow--next');
    const progressEl = section.querySelector('.lifestyle-gallery-v2__progress');
    let progress = null;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      speed: 400,
      watchOverflow: true,
      slidesOffsetAfter: 10,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      breakpoints: {
        769: {
          spaceBetween: 10,
        },
        0: {
          spaceBetween: 16,
        },
      },
      on: {
        init(s) {
          updateArrows(s, prevBtn, nextBtn);
        },
        slideChange(s) {
          progress?.sync();
          updateArrows(s, prevBtn, nextBtn);
        },
        reachBeginning(s) {
          updateArrows(s, prevBtn, nextBtn);
        },
        reachEnd(s) {
          progress?.sync();
          updateArrows(s, prevBtn, nextBtn);
        },
      },
    });

    progress =
      progressEl && window.CarouselProgress
        ? window.CarouselProgress.createSwiperProgress(swiper, progressEl)
        : null;

    initVideoCards(section);

    window.addEventListener('resize', () => {
      progress?.sync();
      updateArrows(swiper, prevBtn, nextBtn);
    });
  }

  function boot() {
    document.querySelectorAll('.lifestyle-gallery-v2').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.lifestyle-gallery-v2').forEach(initSection);
  });
})();
